module.exports = __webpack_public_path__ + "static/img/sec_banner.a21a119.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sec_banner.jpeg
// module id = oO1U
// module chunks = 4